'use strict';let

BaseService=class BaseService{
constructor(){
}

static get type(){
return'service';
}};


module.exports=BaseService;
//# sourceMappingURL=baseService.js.map
